module.exports = __webpack_public_path__ + "fonts/Montserrat-SemiBold.fb428a00.ttf";